import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import Icon from 'common/components/Icon';


class Message extends Component {
  static propTypes = {
    type: PropTypes.string,
    isOpen: PropTypes.bool,
    className: PropTypes.string,
    messageText: PropTypes.string,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    isOpen: false,
    className: '',
    type: 'success',
    messageText: '',
    onClose: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen : false,
    };

    this.close = ::this.close;
  }

  componentDidMount() {
    this.setState({
      isOpen: this.props.isOpen,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen === true) {
      this.setState({
        isOpen: true,
      });
    }

    const hideMessage = setTimeout(() => {
      this.setState({
        isOpen: false,
      });
      clearTimeout(hideMessage);
    }, 8000);
  }

  close(e) {
    e.preventDefault();
    this.setState({
      isOpen: false,
    });
    this.props.onClose(e);
  }

  render() {
    return (
      <div
        className={
          classNames(
            'message',
            this.props.className ,
            'message--' + this.props.type,
            {
              'message--visible': this.state.isOpen,
            }
          )
        }
      >
        <div className="message-text">
          {this.props.messageText}
        </div>
        <div
          className="message__close-btn"
          onClick={this.close}>
          <Icon name="close" />
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    modal: state.modal,
  }),
)(Message);
